export default "__VITE_ASSET__bb7ed401__"